var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 0 0-7.5 0v3z","fill":"currentColor","fillRule":"evenodd"}));
}

Lock.defaultProps = {"fill":"none","height":"24","width":"24"};

module.exports = Lock;

Lock.default = Lock;
